var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.text)?_c('h3',[_vm._v(" "+_vm._s(_vm.bookingStatusText)+" "),_c('img',{style:({width: _vm.size, height: _vm.size}),attrs:{"src":_vm.image}})]):_c('img',{style:({width: _vm.size, height: _vm.size}),attrs:{"src":_vm.image}})}
var staticRenderFns = []

export { render, staticRenderFns }